(() => {
  const init = (root) => {
    if (root.dataset.soterReady === 'true') return;
    root.dataset.soterReady = 'true';

    const gallery = root.querySelector('[data-product-gallery]');
    const media = [...root.querySelectorAll('[data-product-media]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    const options = [...root.querySelectorAll('[data-variant-option]')];
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const sale = root.querySelector('[data-product-sale]');
    const availability = root.querySelector('[data-availability-label]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');
    const cleanImage = root.querySelector('[data-clean-product-image]');
    const cleanThumb = root.querySelector('[data-clean-product-thumb]');
    const lensImage = root.querySelector('[data-lens-product-image]');
    const availableText = root.dataset.availableText || 'זמין להזמנה - המלאי מתעדכן בזמן אמת';
    const unavailableText = root.dataset.unavailableText || 'אזל מהמלאי כרגע';
    const addToCartLabel = root.dataset.addToCartLabel || 'הוספה לסל';
    const soldOutLabel = root.dataset.soldOutLabel || 'אזל מהמלאי';

    let active = Math.max(0, media.findIndex((item) => item.classList.contains('is-active')));

    const show = (id) => {
      const next = media.findIndex((item) => item.dataset.productMedia === String(id));
      if (next < 0) return;

      active = next;
      media.forEach((item, index) => {
        const isActive = index === active;
        item.hidden = !isActive;
        item.classList.toggle('is-active', isActive);
      });
      thumbs.forEach((thumb) => {
        const isActive = thumb.dataset.galleryThumb === String(id);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });
    };

    const move = (direction) => {
      if (media.length < 2) return;
      const next = (active + direction + media.length) % media.length;
      show(media[next].dataset.productMedia);
    };

    const showVariantImage = (option) => {
      if (option.dataset.cleanImage && cleanImage && cleanThumb) {
        cleanImage.src = option.dataset.cleanImage;
        cleanThumb.src = option.dataset.cleanImage;
        if (lensImage) {
          lensImage.src = option.dataset.cleanImage;
          lensImage.alt = option.closest('label')?.querySelector('.soter-product__variant-title')?.textContent || cleanImage.alt;
        }
        show('clean');
        return;
      }

      if (option.dataset.mediaId) show(option.dataset.mediaId);
    };

    thumbs.forEach((thumb) => thumb.addEventListener('click', () => show(thumb.dataset.galleryThumb)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => move(1));

    let start = null;
    gallery?.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      start = { x: event.clientX, y: event.clientY };
    }, { passive: true });
    gallery?.addEventListener('pointerup', (event) => {
      if (!start) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy)) move(dx > 0 ? -1 : 1);
    }, { passive: true });

    options.forEach((option) => option.addEventListener('change', () => {
      if (!option.checked) return;

      variantInput.value = option.value;
      price.textContent = option.dataset.price || '';

      const hasCompare = Boolean(option.dataset.compare);
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !hasCompare;
      sale.hidden = !hasCompare;

      const availableNow = option.dataset.available === 'true';
      addButton.disabled = !availableNow;
      addLabel.textContent = availableNow ? addToCartLabel : soldOutLabel;
      availability.textContent = availableNow ? availableText : unavailableText;

      showVariantImage(option);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      history.replaceState({}, '', url);
    }));

    const selectedOption = options.find((option) => option.checked);
    if (selectedOption) showVariantImage(selectedOption);
  };

  const initAll = () => document.querySelectorAll('[data-soter-product]').forEach(init);

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
